import React, { useRef, useState } from 'react'
import { PlusOutlined, CloseOutlined } from '@ant-design/icons'
import { Button, Divider, Input, Select, Modal } from 'antd'
import { API } from 'src/utils/interceptor'
import { useSelector } from 'react-redux'

const CustomCategorySearch = ({
  categories: initialCategories,
  handleChange,
  setOpen,
  open,
  value,
}) => {
  const [name, setName] = useState('')
  const [categories, setCategories] = useState(initialCategories)
  const venueId = useSelector(state => state.venue.venue._id)

  const inputRef = useRef(null)

  const onNameChange = event => {
    setName(event.target.value)
  }

  const addItem = async e => {
    e.preventDefault()
    if (!name.trim()) return
    const response = await API.post(
      'api2',
      `recipes/categories/${venueId}/createCategory`,
      {
        body: { catgoryName: name },
      },
    )
    setCategories([...categories, response?.category])

    setName('')
    setTimeout(() => {
      inputRef.current?.focus()
    }, 0)
  }

  const deleteCategory = async categoryId => {
    Modal.confirm({
      title: 'Delete Category',
      content: `Are you sure you want to delete this category?`,
      okText: 'Yes',
      cancelText: 'No',
      onOk: async () => {
        try {
          await API.del('api2', `recipes/categories/${venueId}/${categoryId}`)

          // Remove the deleted category from local state
          setCategories(categories.filter(cat => cat._id !== categoryId))

          // If the deleted category was currently selected, clear the selection
          if (value === categoryId) {
            handleChange('category', null)
          }
        } catch (error) {
          console.error('Error deleting category:', error)
        }
      },
    })
  }

  return (
    <Select
      style={{ width: 1100 }}
      placeholder='Select Category'
      open={open}
      onDropdownVisibleChange={visible => {
        if (visible) setOpen(true)
      }}
      onChange={value => handleChange('category', value)}
      onSelect={() => setOpen(false)}
      value={value}
      dropdownRender={menu => (
        <>
          {menu}
          <Divider style={{ margin: '8px 0' }} />
          <div
            style={{
              padding: '0 8px 4px',
              display: 'flex',
              gap: '8px',
            }}
            onMouseDown={e => e.stopPropagation()}
          >
            <Input
              placeholder='Please enter item'
              ref={inputRef}
              value={name}
              onChange={onNameChange}
              onKeyDown={e => e.stopPropagation()}
              style={{ flex: 1 }}
            />
            <Button type='text' onClick={addItem}>
              <PlusOutlined /> Add item
            </Button>
          </div>
        </>
      )}
    >
      {categories.map((item, index) => (
        <Select.Option key={`${item}-${index}`} value={item._id}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <span>{item.name}</span>
            <CloseOutlined
              style={{
                fontSize: '12px',
                color: '#999',
                marginLeft: '8px',
              }}
              onClick={e => {
                e.stopPropagation()
                deleteCategory(item._id)
              }}
            />
          </div>
        </Select.Option>
      ))}
    </Select>
  )
}

export default CustomCategorySearch
